// services/reviewService.ts
import axios from "axios";
import { Review, ReviewToBackend } from "../types/features/Review";
import { MAIN_API_URL } from "../config/api";
import { PaginatedResponse } from "../types/core/PaginatedResponse";

export const reviewService = {
  // 🔓 PUBLIC - Pas de token nécessaire (lecture)
  async getAll(page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Review>> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/reviews`, {
        params: { page, per_page: perPage },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des avis", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire (lecture)
  async getById(id: string): Promise<Review> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/reviews/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement de l'avis", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis (seul l'admin peut créer)
  async create(token: string, data: ReviewToBackend): Promise<Review> {
    try {
      const response = await axios.post(`${MAIN_API_URL}/reviews`, {
        ...data,
        product_name: data.product_name || 'all',
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création de l'avis", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async update(token: string, id: string, data: Partial<ReviewToBackend>): Promise<Review> {
    try {
      const response = await axios.put(`${MAIN_API_URL}/reviews/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'avis", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async delete(token: string, id: string): Promise<void> {
    try {
      await axios.delete(`${MAIN_API_URL}/reviews/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors de la suppression de l'avis", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async deleteMany(token: string, ids: string[]): Promise<void> {
    try {
      const promises = ids.map((id) => this.delete(token, id));
      await Promise.all(promises);
    } catch (error) {
      console.error("Erreur lors de la suppression multiple", error);
      throw error;
    }
  },
};